import React from 'react';
import { Picture, Source, Img } from '@xo-union/tk-component-picture';
import LinkAgent from '../LinkAgent';
import { isRealMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class GalleryLocalFinder extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      custom_screen: isMobile ? 'mobile' : 'desktop'
    }
  }

  static defaultProps = {
    isMobile: false,
    infos: ''
  };

  onWindowResize() {
    this.setState({
      custom_screen: isRealMobile() ? 'mobile' : 'desktop'
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  render() {
    const { infos } = this.props;
    const { custom_screen } = this.state;
    const mobile_img = infos['mobile']['img_id']
    const desktop_img = infos['desktop']['img_id']
    const alt = custom_screen == 'mobile' ? infos['mobile']['img_alt'] : infos['desktop']['img_alt']
    let credit = ''

    if (infos['photo_credit']) {
      credit = <span className={styles["store-photo-credit"]}>{infos['photo_credit']}</span>
    }

    return (
      <div className={styles["local-store-finder-section"]}>
        <div className={styles["local-store-text"]}>
          <div className={styles["local-store-heading"]}>See Your Dream Dress?</div>
          <div className={styles["local-store-description"]}>Try it on at a nearby salon.</div>
          <div className={styles["local-store-button"]}>
            <LinkAgent linkText="Find Your Salon"
              classes='local-store-finder-btn'
              color='primary'
              href={infos['linking_url']}
              target='_blank'
              rel='nofollow' />
          </div>
        </div>
        <div className={styles["local-store-image"]}>
          <Picture pixelDensities={[1,2]} lazy={true}>
            <Source viewport="lg" id={desktop_img} width={900} />
            <Source viewport="md" id={desktop_img} width={768} />
            <Source viewport="xs" id={mobile_img} width={480} />

            <Img className={styles["right-image"]} id={mobile_img} width={480} alt={infos['img_alt'] || alt} />
          </Picture>
          {credit}
        </div>
      </div>
    )
  }
}
